import http from "../../axios/index";

// 根据权限获取养殖场
export function queryBaseDataListByRole() {
  const url = `/baseData/queryBaseDataListByRole`;
  return http.get(url)
}

// 根据养殖场获取养殖场下可用区域
export function queryBaseGroupList(params) {
  const url = `/baseGroup/queryBaseGroupList`;
  return http.post(url, params)
}
